<template>
  <header>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-auto top-logo-header">
          <a href="">
            <img src="../../assets/images/logo-color.png" alt="Dicicil Aja">
          </a>
        </div>
        <div class="col top-search-header">
          <form v-on:submit.prevent="search" id="formSearch">
            <input v-model="keyword" type="text" class="form-control" name="search" id="search-text">
            <i class="fa fa-search" id="search"></i>
          </form>
        </div>
        <div class="col col-lg-3 top-tagline-header font-montserrat">
          <h6 class="small-text">Solusi Semua Kebutuhan Anda</h6>
        </div>
      </div>
      
      <div class="row">
        <div class="col top-auth-menu font-montserrat">
          <span v-if="!isLoggedIn">
            <!-- <router-link :to="{ name: 'login' }">Masuk</router-link> |  -->
            <!-- <router-link :to="{ name: 'register' }">Daftar</router-link> -->
            <b-nav align = "right">
              <b-nav-item><router-link :to="{ name: 'login' }">Masuk</router-link></b-nav-item>
              <b-nav-item-dropdown
                id="my-head-dropdown"
                text="Daftar"
                toggle-class="nav-link-custom"
                right
              >
                <b-dropdown-item><router-link :to="{ name: 'register' }">Daftar Nasabah</router-link></b-dropdown-item>
                <b-dropdown-item><router-link :to="{ name: 'axi_register' }" @click.native="sendAnalytics()">Daftar AXI</router-link></b-dropdown-item>
              </b-nav-item-dropdown>
            </b-nav>
          </span>

          <span v-else>
            <a class="cursor-pointer" @click.prevent="confirmLogout">Keluar</a>
          </span>
        </div>
      </div>
    </div>

    <logout-modal
        ref="logoutModal"
        :isSuccess="isLogoutSuccess"
    />

    <logout-confirmation-modal
        ref="logoutConfirmationModal"
        :logout="logout"
    />
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LogoutModal from '@/components/modals/LogoutModal'
import LogoutConfirmationModal from '@/components/modals/LogoutConfirmationModal'
import { pushDataLayer, registrationAxi, searchProduct } from '../../plugins/analytics';

export default {
  name: 'HeadBar',
  components: {
    LogoutModal,
    LogoutConfirmationModal,
  },
  data() {
    return {
      user: false,
      isLogoutSuccess: false,
      keyword: '',
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn',
    }),
  },
  methods: {
    ...mapActions({
      logoutAction: 'auth/logout',
      setKeyword: 'product/setKeyword',
    }),
    search() {
      // Send Analytics 29
      pushDataLayer(searchProduct(this.keyword));

      this.setKeyword(this.keyword)
      if (this.$route.name !== 'search') {
        this.$router.push({ name: 'search' })
      }
    },
    async logout() {
      try {
        await this.logoutAction()
        this.isLogoutSuccess = true
        this.$refs.logoutConfirmationModal.show()
        this.$refs.logoutModal.show()
        setTimeout(() => {
          window.location.href = '/'
        }, 2000)
      } catch (err) {
        this.isLogoutSuccess = false
        this.$refs.logoutConfirmationModal.show()
        this.$refs.logoutModal.show()
      }
    },
    async confirmLogout() {
      this.$refs.logoutConfirmationModal.show()
    },
    sendAnalytics() {
      // Send Analytics 21
      pushDataLayer(registrationAxi("Registration View", this.$route.path));
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.dropdown-menu {
  z-index: 9999 !important;
}
</style>
